export enum ColorVariantEnum {
	Green = 'green',
	Yellow = 'yellow',
	White = 'white',
	Brand = 'brand',
	Dark = 'dark',
	Light = 'light'
}
